module.exports = __webpack_public_path__ + "static/billboard-bg-video-79fde88c2f55b61fcc08edf3ce64b294.mp4";